module.exports = "/_next/static/images/award-Warta-ekonomi-e9dc08cf28321679186213ec99e6350b.png";